import { zoop } from "../../utils/ZoopConfig";
import { Api } from "../Api";
import { ApiZoop } from "../Api";

export const ValidaCartaoCreditoZoop = async (cardData) => {
  const { data } = await ApiZoop.post(`v1/marketplaces/${zoop.ZOOP_MARKETPLACE_ID}/cards/tokens`, cardData);

  return data;
};

export const Pagamento = async (dataPagamento) => {
  const { data } = await Api.post("/genericnegotiation/create", dataPagamento);
  return data;
};

export const PagamentoDescontoBoleto = async (dataPagamento) => {
  const { data } = await Api.post("/genericnegotiation/createv2", dataPagamento);
  return data;
};

export const SalvaTermo = async (termoData) => {
  const { data } = await Api.post("/genericTerm/create", termoData);
  return data;
};

export const PegaTermo = async (cobranca_id) => {
  const { data } = await Api.get(`/genericTerm/list/${cobranca_id}`);
  return data;
};
